import styled, { css } from 'styled-components';

export const StyledPillText = styled.p`
  ${({ theme, size }) => theme.typography[size === 'small' ? 'label' : 'body']}
  ${({ theme }) => theme.fontFamily.condensed}
  ${({ variant }) => {
    switch (variant) {
      case 'light':
        return css`
          background-color: ${({ theme }) => theme.colors.neutral.bone};
          color: ${({ theme }) => theme.colors.text.secondary};
        `;
      case 'blueberry':
        return css`
          background-color: ${({ theme }) => theme.colors.hero.blueberry};
          color: ${({ theme }) => theme.colors.text.lightest};
        `;
      case 'kale':
        return css`
          background-color: ${({ theme }) => theme.colors.secondary.kale};
          color: ${({ theme }) => theme.colors.text.lightest};
        `;
      case 'egg':
        return css`
          background-color: ${({ theme }) => theme.colors.secondary.egg};
          color: ${({ theme }) => theme.colors.text.secondary};
        `;
      case 'chia':
        return css`
          background-color: ${({ theme }) => theme.colors.secondary.chia};
          color: ${({ theme }) => theme.colors.text.lightest};
        `;
      case 'spinach':
        return css`
          background-color: ${({ theme }) => theme.colors.hero.spinach};
          color: ${({ theme }) => theme.colors.text.lightest};
        `;
      default:
        return css`
          background-color: ${({ theme }) => theme.colors.neutral.darkerFur};
          color: ${({ theme }) => theme.colors.text.lightest};
        `;
    }
  }}
  border-radius: 500px;
  padding: ${({ theme, size }) =>
    size === 'small' ? theme.spacing(2) : theme.spacing(0.6, 4, 1, 4)};
  height: ${({ size }) => (size === 'small' ? '16px' : '30px')};
  text-transform: uppercase;
  width: max-content;
  display: flex;
  justify-content: center;
  align-items: center;
`;
